// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"126":"86eab5862ab332c50771","634":"e8a5a072ec7e7cbacc95"}[chunkId] + ".js";
};